import { render, staticRenderFns } from "./ProformCategoryModule.vue?vue&type=template&id=b9f5359e&scoped=true"
import script from "./ProformCategoryModule.vue?vue&type=script&lang=js"
export * from "./ProformCategoryModule.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b9f5359e",
  null
  
)

export default component.exports